module.exports = __webpack_public_path__ + "img/kaista_logo.69b44bbb.svg";